export default {"src":"/_next/static/media/instagram.25452696.svg","height":40,"width":40};